import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[password-toggle]',
})
export class PasswordToggleDirective {
  private toggleButton;

  constructor(private el: ElementRef) {
    const element = this.el.nativeElement;
    const parent = element.parentNode;

    const btn = document.createElement('a');

    btn.setAttribute('href', 'javascript:void(0)');
    btn.setAttribute('class', 'password-btn');
    btn.innerHTML = '<i class="fas fa-eye"></i>';
    btn.addEventListener('click', () => {
      this.showPassword();
    });

    this.toggleButton = btn;

    const wrapper = document.createElement('div');

    wrapper.setAttribute('class', 'input-wrap password');
    wrapper.append(element as Node);
    wrapper.append(btn);

    parent.append(wrapper);
  }

  private showPassword() {
    const input = this.el.nativeElement;
    input.type = input.type == 'password' ? 'text' : 'password';
    this.toggleButton.classList.toggle('show');
  }
}
